export function dateToString(value: Date) {
  const formatedDay = value.getDate() < 10 ? `0${value.getDate()}` : value.getDate();
  const formatedMonth = value.getUTCMonth() + 1 < 10 ? `0${value.getUTCMonth() + 1}` : value.getUTCMonth() + 1;

  return `${formatedDay}/${formatedMonth}/${value.getUTCFullYear()}`;
}

export function dateTimeToString(value: Date) {
  const formatedDay = value.getDate() < 10 ? `0${value.getDate()}` : value.getDate();
  const formatedMonth = value.getUTCMonth() + 1 < 10 ? `0${value.getUTCMonth() + 1}` : value.getUTCMonth() + 1;

  let hours = `${value.getHours()}`;
  if (hours.length === 1) hours = `0${hours}`;

  let minutes = `${value.getMinutes()}`;
  if (minutes.length === 1) minutes = `0${minutes}`;

  return `${formatedDay}/${formatedMonth}/${value.getUTCFullYear()} ${hours}:${minutes}`;
}
